exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.houses[data-v-ccf6fe0a] {\n    font-size: 15px;\n    font-weight: 550;\n    margin-top: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-ccf6fe0a","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/gmapLocation/traccarMonitoringGMapBeta.vue
// module id = 234
// module chunks = 0